import {defaultTheme} from '@stencil/build-theme';

import useCarousel from '../../../../../../../hooks/useCarousel';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import ViewRoomDetailsChunk from '../../../../../../../../stories/components/hotels/DetailsPageUnif/Rooms/ViewRoomDetails/ViewRoomDetailsChunk';

import * as S from './RecommendedComboList.style';
import {appConfig, gaConfig} from '@stencil/hotels-config';
import HappyRoomSizeIcon from '@stencil/icons/src/HappyRoomSizeIcon/HappyRoomSizeIcon';
import HappyKingBedIcon from '@stencil/icons/src/HappyKingBedIcon/HappyKingBedIcon';
import PaxInfo from '../../Shared/PaxInfo/PaxInfo';

export default function RecommendedComboRoomInfo({
  leftPanelProps,
  isUpsellFlow = false,
  pwiData = [],
  isAltAcco = false,
}) {
  const {multiRoomDefaultNoImagePlacholder} = appConfig;
  // console.log('leftPanelProps::', leftPanelProps);
  const {roomPlanData} = leftPanelProps;
  const {isModalOpen, openModal, closeModal} = useModal();
  const {
    dataList,
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(leftPanelProps?.roomImages, 1);

  return (
    <>
      <S.MultiRoomLeftCol>
        <>
          <S.Room_type_text>
            {(leftPanelProps?.roomCount ? leftPanelProps?.roomCount + ' x ' : '') +
              leftPanelProps?.roomTypeName}
          </S.Room_type_text>
          <S.PaxDetailsDiv>
            <S.PaxDetailsInnerDiv>
              <PaxInfo
                adultCount={leftPanelProps?.roomCount * leftPanelProps?.adultCount}
                childCount={leftPanelProps?.roomCount * leftPanelProps?.childCount}
                showCountTextBelow={true}
              />
            </S.PaxDetailsInnerDiv>
          </S.PaxDetailsDiv>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <S.Room_detail_Wrap>
              <S.RoomImageOuterWrapper isUpsellFlow={!leftPanelProps?.roomImages}>
                <S.RoomTypeImage
                  isUpsellFlow={leftPanelProps?.roomImages}
                  onClick={() => {
                    openModal();
                  }}
                  src={
                    leftPanelProps?.roomImages?.length > 0
                      ? leftPanelProps?.roomImages[0]
                      : multiRoomDefaultNoImagePlacholder
                  }
                />
                {leftPanelProps?.roomImages && leftPanelProps?.roomImages?.length ? (
                  <S.RoomCount
                    onClick={() => {
                      openModal();
                    }}
                  >
                    +{leftPanelProps?.roomImages?.length} Photos
                  </S.RoomCount>
                ) : null}
              </S.RoomImageOuterWrapper>
              {
                // !!(
                //   leftPanelProps?.staticDataForThisRoom?.facilities &&
                //   leftPanelProps?.staticDataForThisRoom?.facilities.length
                // ) ||
                !!(leftPanelProps?.roomDescription && leftPanelProps?.roomDescription.length) ||
                !!(leftPanelProps?.roomImages && leftPanelProps?.roomImages.length) ? (
                  <S.ViewMoreDetailsLink
                    onClick={() => {
                      openModal();
                    }}
                  >
                    View more details
                  </S.ViewMoreDetailsLink>
                ) : null
              }
            </S.Room_detail_Wrap>

            <S.RoomTypeRightPara>
              {leftPanelProps?.roomHighlights?.map(item => {
                if (isAltAcco && item?.identifier === 'GUEST_COUNT') {
                  return null;
                }

                return (
                  <S.UpsellRoomStaticFlex>
                    <img src={item?.iconUrl} width={'22px'} />
                    <S.UpsellRoomStaticTextTypeSpan>{item?.text}</S.UpsellRoomStaticTextTypeSpan>
                  </S.UpsellRoomStaticFlex>
                );
              })}
            </S.RoomTypeRightPara>
          </div>
        </>
      </S.MultiRoomLeftCol>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalStyles={{
          height: '90vh',
          width: '84rem',
        }}
        CloseButton={() => null}
      >
        <ViewRoomDetailsChunk
          roomDescription={leftPanelProps?.description}
          roomTypeName={leftPanelProps?.roomTypeName}
          amenities={leftPanelProps?.amenities}
          roomImages={dataList} // roomImages
          closeModal={closeModal}
          onRightArrowClick={increment}
          onLeftArrowClick={decrement}
          showLeftArrow={isLeftCursorActive}
          showRightArrow={isRightCursorActive}
          leftCursor={leftCursor}
          rightCursor={rightCursor}
          reviews={leftPanelProps?.roomReviews || {}}
          roomHighlights={leftPanelProps?.roomHighlights}
          isAltAcco={isAltAcco}
        />
      </Modal>
    </>
  );
}
